import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBitbucket = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 54,
	height: 54,
	viewBox: "0 0 54 54",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M1.75248 3.01711C1.49998 3.01386 1.24983 3.06591 1.01959 3.16962C0.789351 3.27333 0.584603 3.42618 0.419722 3.61744C0.254842 3.8087 0.133826 4.03374 0.0651717 4.27675C-0.00348253 4.51975 -0.0181111 4.77485 0.0223132 5.02411L7.36689 49.6106C7.4584 50.1562 7.73923 50.6522 8.16006 51.0113C8.58089 51.3704 9.1148 51.5698 9.66801 51.5744H44.9029C45.3176 51.5797 45.7205 51.4359 46.038 51.1691C46.3556 50.9024 46.5668 50.5304 46.6331 50.121L53.9777 5.03276C54.0181 4.7835 54.0035 4.52841 53.9348 4.2854C53.8662 4.04239 53.7452 3.81735 53.5803 3.62609C53.4154 3.43483 53.2106 3.28198 52.9804 3.17827C52.7502 3.07456 52.5 3.02251 52.2475 3.02576L1.75248 3.01711ZM32.6793 35.2415H21.4332L18.3881 19.3326H35.4043L32.6793 35.2415Z",
			fill: "#2684FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M51.6421 19.3329H35.4045L32.6795 35.2418H21.4334L8.1543 51.0037C8.57518 51.3676 9.1118 51.57 9.6682 51.5746H44.9118C45.3265 51.58 45.7293 51.4361 46.0469 51.1694C46.3644 50.9026 46.5756 50.5307 46.6419 50.1213L51.6421 19.3329Z",
			fill: "url(#paint0_linear_113679_575)"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_113679_575",
			x1: 55.3966,
			y1: 23.7881,
			x2: 28.5617,
			y2: 44.7318,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", {
				offset: .18,
				stopColor: "#0052CC"
			}), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#2684FF"
			})]
		}) })
	]
});
const ForwardRef = forwardRef(SvgBitbucket);
export { ForwardRef as ReactComponent };
